import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
import 'parse';
import { Device } from '../model/device.model';
const parse: typeof Parse = require('parse');

@Injectable()
export class AwsService {
  public tunnel: boolean = false
  private cachedUrls: Array<Url>;
  private maxCacheAgeMs = 2 * 60 * 60 * 60 * 1000;

  private changeTunnelValue = new Subject<any>();
  changeTunnelObs = this.changeTunnelValue.asObservable();
  changeTunnel(tunnel) {
    this.tunnel = tunnel
    this.changeTunnelValue.next()
  }

  constructor() {
    this.cachedUrls = [];
  }

  generateUrl(ipMachine, url, i, callback) {
    const AWSService = AWS;
    // console.log("url",url)
    if (environment.isLocal && environment.comparison && ipMachine) {
      let newUrl = 'http://' + ipMachine + ':1337/public/images/' + url
      callback(newUrl, i)
      return
    } else if (environment.isLocal) {
      let newUrl = environment.baseURLPictureLocal + url
      callback(newUrl, i)
      return
    } else if (this.tunnel && parse.User.current().get('isSuperAdmin')
      && url.includes('mp4') === false
      && url.includes('mini') === false) {
      let newUrl = 'http://localhost:1337/public/images/' + url
      callback(newUrl, i)
      return
    }

    // console.log('Generating URL for :', url);
    // Check the cache before asking AWS
    const matchingUrls = this.cachedUrls.filter(cachedUrl => {
      if (cachedUrl.url === url) {
        if (cachedUrl.age() < this.maxCacheAgeMs)
          return true;
      }
      return false;
    });
    // And return latest value if URL present in cache
    if (matchingUrls && matchingUrls.length > 0) {
      // console.log('Matched url from AWS cache :', matchingUrls[matchingUrls.length - 1]);
      callback(matchingUrls.pop().signedUrl, i);
      return;
    }

    AWSService.config.update({
      accessKeyId: environment.accessKeyId,
      secretAccessKey: environment.secretAccessKey
    });
    const s3 = new AWSService.S3({
      apiVersion: '2006-03-01',
      region: 'eu-west-3'
    });

    const myBucket = 'tchek-content';
    const signedUrlExpireSeconds = 60 * 120;

    const urlParams = {
      Bucket: myBucket,
      Key: url,
      Expires: signedUrlExpireSeconds
    };

    s3.getSignedUrl('getObject', urlParams, (err, url) => {
      if (err) {
        console.error('err', err);
      }
      this.cachedUrls.push(new Url(urlParams.Key, url));
      // console.log('Generated new URL from AWS :', url);
      callback(url, i);
    });
  }

  generateUrlPromise(url, ipMachine = undefined): Promise<any> {
    return new Promise((resolve, reject) => {
      this.generateUrl(ipMachine, url, null, resolve);
    });
  }
}

class Url {
  public url: string;
  public signedUrl: string;
  public timestamp: Date;
  constructor(url: string, signedUrl: string) {
    this.url = url;
    this.signedUrl = signedUrl;
    this.timestamp = new Date();
  }

  setUrl(url: string, signedUrl?: string): Url {
    this.url = url;
    this.signedUrl = signedUrl;
    this.timestamp = new Date();
    return this;
  }

  setSignedUrl(signedUrl: string): Url {
    this.signedUrl = signedUrl;
    this.timestamp = new Date();
    return this;
  }

  touch(): Url {
    this.timestamp = new Date();
    return this;
  }

  age(): number {
    return new Date().valueOf() - this.timestamp.valueOf()
  }
}



// WEBPACK FOOTER //
// ./src/app/service/aws.service.ts